export const labels = {
	placeholderLongLabel: {
		label: "Label.MobileCreator.Placeholder.Long",
		default: "Type your text here",
	},

	placeholderMediumLabel: {
		label: "Label.MobileCreator.Placeholder.Medium",
		default: "Text",
	},

	loadingLabel: {
		label: "Label.MobileCreator.Loading",
		default: "Loading...",
	},
} as const;
